import { Box, Button, ClickAwayListener, FormControl, Grid, Grow, IconButton, InputLabel, makeStyles, Paper, Popper, styled, Typography, useControlled } from '@material-ui/core';
import { FormControlLabel, Switch } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';
import { range } from 'lodash';
import React, { useEffect, useMemo, useRef } from 'react';
import { _T } from '../../../include/appI18n';
import { BootstrapInput } from '../../../include/react-components/BootstrapInput';
import Select from '../../../include/react-components/Select';
import { pluralizeAutoSplit } from '../../../include/utils';
import { isCapitalUI } from '../../../include/react-common/theme';
import { CapitalPopper } from '../../../include/react-components/capital/CapitalPopper';
import { capitalTokens } from '../../../include/react-common/capitalTheme';
const PickerPopper = isCapitalUI ? CapitalPopper : Popper;
let nextChildPickerId = 0;
export const defaultAccommodation = {
    childs: 0,
    childAccommodations: []
};
const IconButton2 = styled(IconButton)(({ theme }) => ({
    padding: '8px',
}));
export const ChildAccommodationSelector = React.forwardRef((props, ref) => {
    var _a, _b, _c, _d;
    const [value /*, onChange*/] = useControlled({
        name: 'value',
        controlled: props.value,
        default: Object.assign({}, defaultAccommodation),
        state: 'value',
    });
    const [open, setOpen] = React.useState(false);
    const [popupId] = React.useState(() => `child-accommodation-${++nextChildPickerId}`);
    const [showDropdownContent, setShowDropdownContent] = React.useState(false);
    const anchorRef = useRef(null);
    const menuRef = React.useRef(null);
    const inputRef = React.useRef(null);
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = (event) => {
        if (anchorRef.current && menuRef.current && menuRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    const prevOpen = useRef(open);
    // return focus to the button when we transitioned from !open -> open
    useEffect(() => {
        var _a;
        if (prevOpen.current === true && open === false) {
            if (isCapitalUI)
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            else
                anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);
    useEffect(() => {
        setTimeout(() => setShowDropdownContent(open), 200);
    }, [open]);
    const valueLabel = useMemo(() => {
        return `${value.childs}`;
    }, [value]);
    return (React.createElement(Box, Object.assign({}, ((_a = props.boxProps) !== null && _a !== void 0 ? _a : {}), { height: '100%', component: 'div' }),
        React.createElement("div", { style: { display: 'flex', height: '100%' }, ref: ref },
            React.createElement("div", { style: { display: 'flex', width: '100%', height: '100%' }, ref: anchorRef },
                React.createElement(FormControl, { fullWidth: true, variant: props.variant },
                    React.createElement(InputLabel, { variant: props.variant, classes: {
                            shrink: props.noShrinkLabel ? 'no-shrink' : undefined,
                        } }, props.label),
                    React.createElement(BootstrapInput, { inputRef: inputRef, value: valueLabel, readOnly: isCapitalUI ? true : undefined, inputProps: isCapitalUI ? { 'aria-expanded': open, 'aria-controls': open ? popupId : undefined, 'aria-haspopup': 'dialog', 'aria-label': typeof props.label === 'string' ? props.label : _T.COMMON_CHILDREN } : undefined, onKeyDown: isCapitalUI ? event => {
                            if (['Enter', ' ', 'ArrowDown'].includes(event.key)) {
                                event.preventDefault();
                                handleToggle();
                            }
                        } : undefined, onInput: (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                        }, style: { caretColor: 'transparent' }, "aria-controls": open ? (isCapitalUI ? popupId : 'menu-list-grow') : undefined, "aria-haspopup": "true", onClick: handleToggle, endAdornment: React.createElement(ArrowDropDown, null) })),
                React.createElement(PickerPopper, Object.assign({}, (isCapitalUI ? { onClose: () => setOpen(false), 'aria-label': typeof props.label === 'string' ? props.label : _T.COMMON_CHILDREN } : {}), { className: 'mui-popper-dropdown', open: open, anchorEl: anchorRef.current, role: isCapitalUI ? 'dialog' : undefined, transition: true, style: {
                        zIndex: isCapitalUI ? undefined : 9999,
                        width: isCapitalUI ? Math.max((_c = (_b = anchorRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth) !== null && _c !== void 0 ? _c : 0, 280) : (_d = anchorRef.current) === null || _d === void 0 ? void 0 : _d.clientWidth,
                        maxHeight: '300px',
                    } }), ({ TransitionProps, placement }) => (React.createElement(Grow, Object.assign({}, TransitionProps, { style: {
                        transformOrigin: placement === 'bottom' ? 'left top' : 'left bottom',
                        marginTop: placement === 'bottom' ? '2px' : 0,
                        marginBottom: placement !== 'bottom' ? '2px' : 0,
                    } }),
                    React.createElement(Paper, { elevation: 4 },
                        React.createElement(ClickAwayListener, { onClickAway: handleClose },
                            React.createElement(Box, { width: "100%", height: "100%", id: isCapitalUI ? popupId : undefined },
                                React.createElement(ChildAccommodationSelectorStatic, Object.assign({}, props, { handleClose: handleClose, visible: showDropdownContent }))))))))))));
});
export const useDropdownStyles = makeStyles((theme) => ({
    root: Object.assign({ background: '#ffffff', 
        //boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
        width: '100%', height: '100%', padding: '12px', borderRadius: isCapitalUI ? capitalTokens.radius.popover : 4 }, (isCapitalUI ? { boxSizing: 'border-box', boxShadow: 'none', minWidth: 0 } : {})),
    container: Object.assign({ gap: '12px' }, (isCapitalUI ? { '& > .MuiGrid-container': { gap: 8, alignItems: 'center' } } : {})),
    lbl: {
        fontSize: '15px',
        marginBottom: '4px',
        display: 'block',
        alignContent: 'center',
    },
    small: {
        fontWeight: 'normal',
        fontSize: '12px',
        color: isCapitalUI ? theme.palette.text.secondary : '#777777',
    },
    counter: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        margin: '4px 0',
    },
    btn: Object.assign(Object.assign({}, (isCapitalUI ? { borderRadius: 12 } : {})), { width: '40px', minWidth: '40px', maxWidth: '40px', height: '40px', minHeight: '40px', maxHeight: '40px', fontSize: '14px', fontWeight: 'bold', '&.minus': {}, '&.plus': {} }),
    select: {
        padding: '19px 12px 18px',
    },
    switchRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingTop: '6px',
    },
}));
export const ChildAccommodationSelectorStatic = React.forwardRef((props, ref) => {
    var _a;
    const classes = useDropdownStyles();
    const [value /*, onChange*/] = useControlled({
        name: 'value',
        controlled: props.value,
        default: Object.assign({}, defaultAccommodation),
        state: 'value',
    });
    return (React.createElement(Paper, { className: classes.root, elevation: 2 },
        React.createElement(Grid, { container: true, justifyContent: "space-between", className: classes.container },
            React.createElement(Grid, { item: true, xs: 12, container: true, justifyContent: "space-between" },
                React.createElement("span", { className: classes.lbl },
                    "\u0414\u0435\u0442\u0438",
                    React.createElement("br", null),
                    React.createElement("span", { className: classes.small },
                        _T.COMMON_TO,
                        " ",
                        props.maxChildAge,
                        " ",
                        pluralizeAutoSplit(props.maxChildAge, _T.COMMON_AGES_PLURAL))),
                React.createElement(Grid, { item: true, xs: "auto", className: classes.counter },
                    React.createElement(Button, { variant: 'contained', color: 'primary', className: `${classes.btn} minus`, disabled: value.childs <= props.minChilds, onClick: () => props.onChange({ childs: value.childs - 1, childAccommodations: value.childAccommodations.slice(0, value.childs - 1) }) }, "-"),
                    React.createElement("span", { className: classes.lbl }, value.childs),
                    React.createElement(Button, { variant: 'contained', color: 'primary', className: `${classes.btn} plus`, disabled: value.childs >= props.maxChilds, onClick: () => props.onChange({ childs: value.childs + 1, childAccommodations: [...value.childAccommodations, { age: 2, withPlace: false }] }) }, "+"))),
            value.childs > 0 ? React.createElement("hr", { className: "my-1" }) : null,
            value.childAccommodations.map((x, i) => (React.createElement(React.Fragment, { key: i },
                React.createElement(Grid, { item: true, xs: 12, container: true, justifyContent: "space-between" },
                    React.createElement("span", { className: classes.lbl }, _T.COMMON_CHILD_AGE),
                    React.createElement(Grid, { item: true, xs: "auto" },
                        React.createElement(Select, { classes: { select: classes.select }, key: i, value: x.age, onChange: (e) => props.onChange(Object.assign(Object.assign({}, value), { childAccommodations: [...value.childAccommodations.slice(0, i), Object.assign(Object.assign({}, x), { age: e.target.value == null ? 0 : Number.parseInt(e.target.value || '0') }), ...(value.childAccommodations.length >= i ? value.childAccommodations.slice(i + 1) : [])] })), label: '' }, range(0, props.maxChildAge).map(o => (React.createElement("option", { key: o, value: o },
                            o,
                            " ",
                            pluralizeAutoSplit(o, _T.COMMON_AGES_PLURAL)))))))))),
            props.showChildsWithPlaceOnlySwitch && value.childs > 0 ? React.createElement(React.Fragment, null,
                React.createElement(Grid, { item: true, xs: 12, className: classes.switchRow },
                    React.createElement(FormControlLabel, { control: React.createElement(Switch, { color: "primary", checked: !!props.childsWithPlaceOnly, onChange: (e) => props.onChildsWithPlaceOnlyChange && props.onChildsWithPlaceOnlyChange(e.target.checked) }), label: (_a = props.childsWithPlaceOnlyLabel) !== null && _a !== void 0 ? _a : _T.NEW_TOUR_SEARCH_CHILD_WITH_PLACE_ONLY_LABEL }))) : null)));
    return (React.createElement("div", { ref: ref, style: { width: "100%", height: "100%" } },
        React.createElement("div", { className: classes.root },
            React.createElement("span", { className: classes.lbl },
                "\u0414\u0435\u0442\u0438",
                React.createElement("br", null),
                React.createElement("span", { className: classes.small },
                    _T.COMMON_TO,
                    " ",
                    props.maxChildAge,
                    " ",
                    pluralizeAutoSplit(props.maxChildAge, _T.COMMON_AGES_PLURAL))),
            React.createElement("div", { className: classes.counter },
                React.createElement(Button, { variant: 'contained', color: 'primary', className: `${classes.btn} minus`, disabled: value.childs <= props.minChilds, onClick: () => props.onChange({ childs: value.childs - 1, childAccommodations: value.childAccommodations.slice(0, value.childs - 1) }) }, "-"),
                React.createElement(Typography, { variant: 'subtitle2', className: "count" }, value.childs),
                React.createElement(Button, { variant: 'contained', color: 'primary', className: `${classes.btn} plus`, disabled: value.childs >= props.maxChilds, onClick: () => props.onChange({ childs: value.childs + 1, childAccommodations: [...value.childAccommodations, { age: 2, withPlace: false }] }) }, "+")),
            React.createElement("hr", { className: "my-2" }),
            React.createElement("div", { className: "child-age-selects" }, value.childAccommodations.map((x, i) => (React.createElement(React.Fragment, null,
                React.createElement(Typography, { variant: 'subtitle1' }, _T.COMMON_CHILD_AGE),
                React.createElement(Select, { key: i, value: x.age, onChange: (e) => props.onChange(Object.assign(Object.assign({}, value), { childAccommodations: [...value.childAccommodations.slice(0, i), Object.assign(Object.assign({}, x), { age: e.target.value == null ? 0 : Number.parseInt(e.target.value || '0') }), ...(value.childAccommodations.length >= i ? value.childAccommodations.slice(i + 1) : [])] })), label: '' }))))))));
});
